import { Circle, Marker, Pane, Tooltip, useMapEvents } from "react-leaflet";
import { OperationNames } from "Types/operation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { changeModal } from "Redux/modalSlice";

import MapContainer from "Components/MapContainer";
import MarkerClusterGroup from "react-leaflet-cluster";
import { useCallback, useState } from "react";
import L, { MarkerCluster, icon } from "leaflet";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import SourceSvg from "Assets/Images/Survey/source-icon.svg";
import useSurveys from "Hooks/useSurveys";

import ArcAndShadow from "./paths/arcAndShadow";
import ArcAndShadow2 from "./inventoryPath/arcAndShadow";
import PathRoute from "./paths/route";
import LinePath from "./paths/line";
import Points from "./Points";
import Route from "./Route";
import Stations from "./Stations";
import MarkerClusterShow from "./clusters/MarkerClusterShow";
import Pointwise from "./Pointwise";
import Zones from "./Zones";
import HeatMap from "./heatMapGradian/heatmap";
import HeatMap2 from "./heatMap2";
import TravelHeatMap2 from "./travelHeatMap2";
import TrafficHeatMap2 from "./trafficHeatMap2";
import TravelHeatMap from "./heatMapGradian/travelHeatMap";
import TrafficHeatMap from "./heatMapGradian/trafficHeatMap";
import ContextMenu from "./contextMenu";
import ContextMenu2 from "./contextMenu2";
import AddSurvayLoc from "./addSurvayLoc";
import Camera from "./camera";
import Travel from "./travel";
import Traffic from "./traffic";
import TrafficFleet from "./trafficFleet";
import TrafficMarkerCluster from "./clusters/trafficMarkerCluster";
import TravelMarkerCluster from "./clusters/travelMarkerCluster";
import TrafficFleetMarkerCluster from "./clusters/trafficFleetMarkerCluster";
import CameraMarkerCluster from "./clusters/cameraMarkerCluster";
import Events from "./event";
import Waybill from "./waybill";
import WaybillMarkerCluster from "./clusters/waybillMarkerCluster";
import WaybillHeatMap from "./heatMapGradian/waybillHeatmap";
import Passage from "./passage";
import MarginPark from "./marginPark";
import MarginParkHeatMap from "./heatMapGradian/marginParkHeatMap";
import MarginParkMarkerCluster from "./clusters/marginParkMarkerCluster";

const ICON_SIZE = 22;

function MapHandler() {
  const dispatch = useAppDispatch();
  const { name } = useAppSelector((state) => state.operation);

  const map = useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      const center = { lat, lng };
      const operationName: OperationNames[] = ["create-path", "edit-path"];
      // if (name !== null && operationName.includes(name)) dispatch(changeModal({ status: "add-station", data: { ...center } }));
    },
  });
  return <></>;
}

export default function Map() {
  const { page } = useAppSelector((state) => state.page);

  const { starDashboardVisible } = useAppSelector((state) => state.services);

  return (
    <MapContainer>
      <MapHandler />
      {starDashboardVisible ? null : (
        <>
          {" "}
          <Route />
          <Points />
        </>
      )}
    </MapContainer>
  );
}
